import React from "react";
import {Col, Row} from "react-bootstrap";
import {useSelector} from "react-redux";
import {getDateObjectLocal} from "../../helpers/Date";
import WordDocumentReact from "../wordDocuments/wordDocuments";
import SchuelerDetailsBerlin from "./SchuelerDetailsBerlin";
import SchuelerDetailsBrandenburg from "./SchuelerDetailsBrandenburg";

const SchuelerDetails = ({props}) => {
  const {activeId, setView} = props;
  const schuelerlist = useSelector(st => st.schueler);
  const schueler = schuelerlist.find(s => s.id === activeId);
  const currentKlausur = useSelector(st => st.currentKlausur);
  const currentUser = useSelector(st => st.currentUser);
  const textbausteine = useSelector(st => st.textbausteine);
  const companies = useSelector(st => st.companies);
  const land = companies.find(c => c.id === parseInt(currentKlausur.companyId))?.land;

  const {createdAt, updatedAt, id} = schueler;
  const updatedString = updatedAt ? ` (Letzte Aktualisierung: ${getDateObjectLocal(updatedAt).dateTime})` : "";
  const idString = `, id: ${id}`;
  // console.log({ schueler }, Object.keys(schueler));

  return (
    <div className="p-3" style={{border: "1px solid grey", borderRadius: "5px"}}>
      {/* <img src = {URL.createObjectURL(logo.imageBlob)}></img> */}
      <h4>{`${schueler.nachname}, ${schueler.vorname}`}</h4>
      <p>
        {`erstellt am ${getDateObjectLocal(createdAt).dateTime}${updatedString}`}
        <small>{idString}</small>
      </p>
      {land === "Berlin" && <SchuelerDetailsBerlin props={props} />}
      {land === "Brandenburg" && <SchuelerDetailsBrandenburg props={props} />}
      <Row>
        <Col>
          <button className="btn btn-outline-dark" onClick={() => setView("formEdit")}>
            Gutachten bearbeiten
          </button>
        </Col>{" "}
        <Col>
          <button className="btn btn-outline-dark" onClick={() => setView("buttons")}>
            Zurück zur Liste
          </button>
        </Col>
        <Col>
          <button
            className="btn btn-outline-dark"
            onClick={() =>
              WordDocumentReact.createEinzelgutachten(currentUser, currentKlausur, schueler, textbausteine, companies, schuelerlist)
            }
          >
            Gutachten
          </button>
        </Col>
      </Row>
    </div>
  );
};
export default SchuelerDetails;
